<template>
  <div class="page" :class="{ inApp: $root.$data.isApp|| this.$root.miniprogram }">
    <common-title titleName="填写发票信息" :zIndex="1000"></common-title>
    <div class="invoice-form">
      <div class="form-item">
        <div class="form-label">发票类型</div>
        <span class="form-value">电子普通发票</span>
      </div>
      <div class="form-item">
        <div class="form-label">发票内容</div>
        <span class="form-value">商品类别</span>
      </div>
      <div class="form-item">
        <div class="form-label">抬头类型</div>
        <span
          class="form-type"
          :class="{ active: TypeOptionsIndex === index }"
          v-for="(item, index) in TypeOptions"
          @click="change(index)"
          :key="index"
          >{{ item.label }}</span
        >
      </div>
      <div class="form-item">
        <div class="form-label">抬头名称</div>
        <input
          type="text"
          maxlength="50"
          v-model="headName"
          placeholder="请输入发票抬头"
        />
      </div>

      <template v-if="TypeOptionsIndex === 1">
        <div class="form-item">
          <div class="form-label">单位税号</div>
          <input type="text" v-model="unitTaxId" placeholder="请输入单位税号" />
        </div>
        <template v-if="isExtraFieldsExpanded">
          <div class="form-item">
            <div class="form-label">注册地址</div>
            <input type="text" maxlength="200" v-model="registerAddress" placeholder="选填" />
          </div>
          <div class="form-item">
            <div class="form-label">注册电话</div>
            <input type="text" maxlength="20" v-model="registerPhone" placeholder="选填" />
          </div>
          <div class="form-item">
            <div class="form-label">开户银行</div>
            <input type="text" maxlength="200" v-model="bankName" placeholder="选填" />
          </div>
          <div class="form-item">
            <div class="form-label">银行账号</div>
            <input type="text" maxlength="20" v-model="bankAccount" placeholder="选填" />
          </div>
        </template>
      </template>
      <div class="arrow" v-if="TypeOptionsIndex === 1" @click="toggleExtraFields">
        <span>{{ !isExtraFieldsExpanded ? '展开' : '收起' }}</span>
        <img
          :class="{ rotate: isExtraFieldsExpanded }"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/down.png"
          alt=""
        />
      </div>
    </div>
    <div class="email">
      <div class="form-item">
        <div class="form-label">收票邮箱</div>
        <input type="text" v-model="receiveEmail" placeholder="请填写正确的邮箱格式，非必填" />
      </div>
    </div>
    <div class="foot" @click="handleApplyInvoice">
      <div>申请开票</div>
    </div>
  </div>
</template>

<script>
import { reqInvoiceIssue } from '@/api/personal/index';

export default {
  name: 'InvoiceForm',

  data() {
    return {
      orderNo:this.$route.query.orderNo,
      // 抬头类型相关
      TypeOptions: [
        { label: '个人', value: 0 },
        { label: '单位', value: 1 },
      ],
      TypeOptionsIndex: -1,
      headName: '',
      unitTaxId: '', // 单位税号
      registerAddress: '',
      registerPhone: '',
      bankName: '',
      bankAccount: '',
      isExtraFieldsExpanded: false,
      receiveEmail: '',
      flag:false
    };
  },
  computed: {
    // 收起/展开按钮文本
    extraFieldsToggleText() {
      return this.isExtraFieldsExpanded ? '收起' : '展开';
    },
  },
  methods: {
    change(index) {
      this.TypeOptionsIndex = index;
      this.headName = index == 0 ? '个人' : '';
      this.isExtraFieldsExpanded = false;
    },
    toggleExtraFields() {
      this.isExtraFieldsExpanded = !this.isExtraFieldsExpanded;
    },
    // 校验邮箱是否合法
    validateEmail(email) {
      const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      return reg.test(email);
    },
    async handleApplyInvoice() {
      if(this.TypeOptionsIndex===-1){
        this.$toast('请选择抬头类型'); 
        return
      }
      // 校验必填项
      if (!this.headName) {
        this.$toast(`请输入${this.TypeOptionsIndex == 0 ? '个人' : '单位'}抬头名称`); // 假设用了类似 vant 的提示，可根据实际 UI 库调整
        return;
      }
    
      if (!this.unitTaxId && this.TypeOptionsIndex === 1) {
        this.$toast('请输入单位税号');
        return;
      }
      // 校验邮箱
      if (this.receiveEmail && !this.validateEmail(this.receiveEmail)) {
        this.$toast('请填写正确的邮箱格式');
        return;
      }

      let params = {
        buyerName: this.headName,
        naturalMark: this.TypeOptionsIndex?0:1,
        orderNo: this.orderNo,
        pushEmail: this.receiveEmail,
      };
      if (this.TypeOptionsIndex === 1) {
        params.buyerAddress=this.registerAddress;
        params.buyerBankName=this.bankName;
        params.buyerBankNumber=this.bankAccount;
        params.buyerTaxNo=this.unitTaxId;
        params.buyerTelephone=this.registerPhone;
      }
      if(this.flag)return;
      this.flag=true;
      const { code, msg } = await reqInvoiceIssue(params);
      if(code){
        this.$toast(msg)
      }else{
        this.$toast('申请成功，发票将在24小时内开具，请稍后查看');
        setTimeout(()=>{
          this.$router.go(-1)
        },2000)
      }
      this.flag=false
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  min-height: 100vh;
  padding: 129px 36px 180px 36px;
  background: #f7f8fc;
}
.invoice-form {
  padding: 24px 29px;
  background: #fff;
  border-radius: 14px;
}
.email {
  margin-top: 22px;
  padding: 0 29px;
  background: #fff;
  border-radius: 14px;
}
.form-item {
  display: flex;
  align-items: center;
  height: 87px;
  margin-bottom: 15px;
  border-bottom: 1px solid #f6f6f6;
  .form-label {
    flex-shrink: 0;
    width: 180px;
    // margin-right: 10px;
    // margin-right: 58px;
    color: #333;
    font-weight: 400;
    font-size: 29px;
    text-align: left;
  }
  .form-value {
    color: #333;
    font-weight: 400;
    font-size: 25px;
  }
  .form-type {
    width: 94px;
    height: 43px;
    margin-right: 18px;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 43px;
    text-align: center;
    background: #f0f2f2;
    border-radius: 22px;
  }
  .form-type.active {
    color: #ff7f41;
    background: rgba(255, 127, 65, 0.1);
    border: 2px solid #ff7f41;
  }
  input {
    width: 100%;
    color: #333;
    font-weight: 400;
    font-size: 25px;
  }
}
.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  span {
    padding-right: 4px;
    color: #999;
    font-weight: 400;
    font-size: 22px;
  }
  img {
    width: 29px;
    height: 29px;
  }
  .rotate {
    transform: rotate(180deg);
    transition: transform 0.1s ease; /* 可选：添加过渡效果 */
  }
}
.radio-group {
  display: inline-block;
}
.radio-label {
  margin-right: 15px;
}
.form-input {
  width: 200px;
  padding: 5px;
}
.toggle-btn {
  margin-bottom: 10px;
  margin-left: 90px;
}
.submit-btn {
  margin-left: 90px;
  padding: 8px 15px;
  color: #fff;
  background-color: #f39800;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.inApp {
  padding-top: 36px;
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 750px;
  height: 167px;
  background: #fff;
  border-radius: 22px 22px 2px 2px;
  box-shadow: 0 -4px 14px 0 rgba(0, 0, 0, 0.05);
  div {
    width: 678px;
    height: 80px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
</style>
